module.exports = __webpack_public_path__ + "img/video-icon.1caba23f.png";